import { render, staticRenderFns } from "./ModalIdle.vue?vue&type=template&id=313dba9a"
import script from "./ModalIdle.vue?vue&type=script&lang=js"
export * from "./ModalIdle.vue?vue&type=script&lang=js"
import style0 from "./ModalIdle.vue?vue&type=style&index=0&id=313dba9a&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports